// extracted by mini-css-extract-plugin
module.exports = {"collection-page":"collection_collection-page__1ubv-","title":"collection_title__1RBp2","items":"collection_items__2TYof","collection-item":"collection_collection-item__7uRGE"};